import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useRegenerateThirdPartyToken from '../../../../hooks/dashboard/settings/useRegenerateThirdPartyToken';
import {
  RegenerateThirdPartyTokenInitialValues,
  RegenerateThirdPartyTokenInterface,
  RegenerateThirdPartyTokenSchema,
  ThirdPartyAccessInterface,
} from '../../../../models/dashboard/settings/third-party-access.model';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import { TableContext } from '../../../Table/TableContext';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface RegenerateThirdPartyTokenModalProps {
  data: ThirdPartyAccessInterface;
}

const RegenerateThirdPartyTokenModal: React.FC<
  RegenerateThirdPartyTokenModalProps
> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);
  const { regenerateThirdPartyToken, loading } = useRegenerateThirdPartyToken();

  const onSubmit = (values: RegenerateThirdPartyTokenInterface) => {
    regenerateThirdPartyToken(data, values, () => {
      modalContext?.setShowModal(false);
      tableContext?.setRefreshTable(!tableContext.refreshTable);
    });
  };

  return (
    <ModalContainer
      label='Regenerate Token'
      description={`We'll email ${data.partnerEmail} a new link to generate their key.`}
    >
      <FormComponent
        initialValues={RegenerateThirdPartyTokenInitialValues}
        schema={RegenerateThirdPartyTokenSchema}
        onSubmit={onSubmit}
      >
        <TextInputField
          type='date'
          label='Date of Expiry'
          name='expiresAt'
          id='expiresAt'
          placeholder='Select date of expiry'
        />

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton className='fill' loading={loading}>
            Regenerate
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default RegenerateThirdPartyTokenModal;

const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
`;
